import CurrencyCode from 'components/Currency'
import I18n from 'components/I18n'
import Money from 'components/Money'
import Tooltips from 'components/Tooltips'
import messages from 'lang'
import React, { ReactNode, useState } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import {
  Currency,
  Drawer,
  DRAWER_HIDE_DELAY,
  Error,
  InformationIcon,
  Input,
  Label,
  Message,
  Wrapper
} from './TradeInput'

interface InputProps {
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange: (val: string) => void
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  value: string
}

interface MetaProps {
  dirty: boolean
  error?: ReactNode
}

type PropsType = WrappedComponentProps & {
  best?: {
    price: number
    side: 'ask' | 'bid'
  }
  className?: string
  currency: string
  input: InputProps
  meta: MetaProps
}

type DrawerPropsType = PropsType & { isFocussed: boolean }

const getDrawerContent = ({ best, currency, input, isFocussed, meta }: DrawerPropsType) => {
  if (meta.dirty && meta.error) {
    return <Error data-e2e='limitPriceError'>{meta.error}</Error>
  }

  if (isFocussed && best) {
    return (
      <Message collapsed={false}>
        <a
          tabIndex={0}
          role='button'
          onClick={() => {
            input.onChange(String(best.price))
          }}
          onKeyPress={() => {
            input.onChange(String(best.price))
          }}
        >
          {best.side === 'ask' ? (
            <I18n data={messages.current_ask} />
          ) : (
            <I18n data={messages.current_bid} />
          )}{' '}
          <Money amount={best.price} currency={currency} />
        </a>
      </Message>
    )
  }

  return null
}

const LimitPriceInput = (props: PropsType) => {
  const { currency, input, intl } = props
  const [isFocussed, setFocussed] = useState(false)
  const drawerContent = getDrawerContent({ ...props, isFocussed })
  return (
    <Wrapper className={props.className}>
      <Label>
        <I18n data={messages.label_price} />
        <Tooltips name='ticket_field.limitprice' placement='top' wrap={false}>
          <InformationIcon />
        </Tooltips>
      </Label>
      <Input
        autoComplete='off'
        currency={currency}
        data-e2e='limitPrice'
        data-lpignore='true'
        {...input}
        onChange={(ev) => {
          input.onChange(ev.target.value)
        }}
        onBlur={(ev) => {
          setTimeout(() => setFocussed(false), DRAWER_HIDE_DELAY)
          if (input.onBlur) input.onBlur(ev)
        }}
        onFocus={(ev) => {
          setFocussed(true)
          if (input.onFocus) input.onFocus(ev)
        }}
        placeholder={intl.formatMessage(messages.placeholder_price)}
        squaredBottom={!!drawerContent}
      />
      <Drawer className='limit-input-drawer' collapsed={!drawerContent}>
        {drawerContent}
      </Drawer>
      <Currency>
        <CurrencyCode code={currency} />
      </Currency>
    </Wrapper>
  )
}

export default injectIntl(LimitPriceInput)
